import arrowRightBlack from "@/assets/images/user/arrowRightBlack.svg";
import icBus from "@/assets/images/user/icBus.svg";
import icSubway from "@/assets/images/user/icSubway.svg";
import infoBox from "@/assets/images/user/infoBox.svg";
import location from "@/assets/images/user/location.png";
import TitleBox from "@/components/user/common/TitleBox";

export default function Location() {
    return (
        <div className="max-w-[1400px] w-full mx-auto px-[20px] xl:px-0">
            <TitleBox title="LOCATION" text="오시는 길" />
            <div className="p-[28px_0_120px] md:p-[48px_0_160px]">
                <div className="relative overflow-hidden rounded-[20px_0_20px_0] border-2 border-transparent bg-origin-border shadow-[8px_8px_0_0_#D456A0] bg-gradient-to-br from-[#E64C88] to-[#3734C3] md:rounded-[60px_0_60px_0] md:border-4 md:shadow-[16px_16px_0_0_#D456A0]">
                    <img src={location} alt="지도" />
                </div>
                <div className="pt-[40px] flex flex-col gap-[50px] font-['GongGothicMedium'] md:pt-[80px] md:gap-[60px] xl:flex-row xl:gap-0">
                    <div className="flex flex-col gap-[15px] text-black xl:w-[40%]">
                        <p className="text-[28px] md:text-[50px]">Public Transport</p>
                        <p className="text-[20px] md:text-[24px]">대중교통 오시는 길</p>
                    </div>
                    <div className="flex flex-col gap-[36px] md:gap-[40px] xl:gap-[60px] xl:flex-1">
                        <div className="flex flex-col gap-[25px]">
                            <div className="flex items-center gap-[16px] text-[24px] text-black md:text-[28px]">
                                <img src={icSubway} alt="지하철" />
                                <p>지하철역</p>
                            </div>
                            <div className="flex flex-col gap-[5px] xl:flex-row xl:items-center xl:gap-[8px]">
                                <div className="flex gap-[8px]">
                                    <span className="text-[#D93B4A] text-[18px] px-[12px] leading-[35px] border-2 border-[#D93B4A] rounded-[30px]">
                                        신분당
                                    </span>
                                    <span className="text-[#1D6DD6] text-[18px] px-[12px] leading-[35px] border-2 border-[#1D6DD6] rounded-[30px]">
                                        경강선
                                    </span>
                                    <img src={arrowRightBlack} alt="화살표" className="hidden xl:block" />
                                </div>
                                <p className="flex items-center gap-[12px] text-[18px] text-[#469F9E] leading-[40px]">
                                    <span className="text-[20px] text-[#666]">1번 출구</span>
                                    <span>도보 1분 거리</span>
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-col gap-[25px]">
                            <div className="flex items-center gap-[16px] text-[24px] text-black md:text-[28px]">
                                <img src={icBus} alt="버스" />
                                <p>버스정류장</p>
                            </div>
                            <p className="flex items-center gap-[12px] text-[18px] text-[#469F9E] leading-[40px]">
                                <span className="text-[20px] text-[#666]">판교역동편(07570)</span>
                                <span>32m</span>
                            </p>
                            <div className="flex flex-col gap-[24px]">
                                <div className="flex flex-col gap-[5px] xl:flex-row xl:items-center xl:gap-[8px]">
                                    <div className="flex items-center gap-[8px]">
                                        <span className="text-[#4DABAA] text-[18px] px-[12px] leading-[35px] border-2 border-[#4DABAA] rounded-[30px]">
                                            일반
                                        </span>
                                        <img src={arrowRightBlack} alt="화살표" className="hidden xl:block" />
                                    </div>
                                    <ul className="flex flex-wrap gap-y-[5px] gap-x-[20px] leading-[40px] text-[18px] text-black md:text-[20px]">
                                        <li>101</li>
                                        <li>310</li>
                                        <li>340</li>
                                        <li>360</li>
                                        <li>370</li>
                                        <li>380</li>
                                        <li>390</li>
                                        <li>55</li>
                                        <li>누리1-4</li>
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-[5px] xl:flex-row xl:items-center xl:gap-[8px]">
                                    <div className="flex items-center gap-[8px]">
                                        <span className="text-[#75B54F] text-[18px] px-[12px] leading-[35px] border-2 border-[#75B54F] rounded-[30px]">
                                            마을
                                        </span>
                                        <img src={arrowRightBlack} alt="화살표" className="hidden xl:block" />
                                    </div>
                                    <ul className="flex flex-wrap gap-y-[5px] gap-x-[20px] leading-[40px] text-[18px] text-black md:text-[20px]">
                                        <li>107</li>
                                        <li>3</li>
                                        <li>32</li>
                                        <li>602</li>
                                        <li>602-1B(평일)</li>
                                        <li>602-2B</li>
                                        <li>66</li>
                                        <li>71</li>
                                        <li>73</li>
                                        <li>75</li>
                                        <li>76</li>
                                        <li>812</li>
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-[5px] xl:flex-row xl:items-center xl:gap-[8px]">
                                    <div className="flex items-center gap-[8px]">
                                        <span className="text-[#E7765D] text-[18px] px-[12px] leading-[35px] border-2 border-[#E7765D] rounded-[30px]">
                                            직행
                                        </span>
                                        <img src={arrowRightBlack} alt="화살표" className="hidden xl:block" />
                                    </div>
                                    <ul className="flex flex-wrap gap-y-[5px] gap-x-[20px] leading-[40px] text-[18px] text-black md:text-[20px]">
                                        <li>4000</li>
                                        <li>6003</li>
                                        <li>9007</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col gap-[25px]">
                            <p className="text-[24px] text-black md:text-[28px]">주차안내</p>
                            <ul className="flex flex-col gap-[12px] font-['GongGothicLight'] text-black md:text-[18px]">
                                <li className="flex gap-[12px] items-start md:items-center">
                                    <img src={infoBox} alt="아이콘" />
                                    <p>행사장 방문 시 가급적 대중교통을 이용해 주시기 바랍니다.</p>
                                </li>
                                <li className="flex gap-[12px] items-start md:items-center">
                                    <img src={infoBox} alt="아이콘" />
                                    <p>자가용 이용 시 인근 유료 주차장을 이용해 주세요.</p>
                                </li>
                                <li className="flex gap-[12px] items-start md:items-center">
                                    <img src={infoBox} alt="아이콘" />
                                    <p>
                                        9월 20일(토) 13:00 ~ 17:00에는 보평고등학교 후문 주차장을 무료로 이용하실 수
                                        있습니다.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
